import React from 'react';
import './Checkout.css';


function Checkout() {
    return (
        <div className='d'>checkout</div>


    )
}

export default Checkout;